import React from 'react';
import CourierRoutePage from './CourierRoutePage';
import { ROUTE_PAGES } from '../data/routePages';

const CourierToCanadaPage = () => <CourierRoutePage page={ROUTE_PAGES.canada} />;

export default CourierToCanadaPage;
